/**
 * Token Service
 */
export abstract class TokenService {

  /*
   * 设置access_token
   * */
  abstract setAccessToken(): Promise<string>;

  /*
  *  获取access_token
  * */
  abstract getAccessToken(): Promise<string>;

}


